import React from 'react'

const HvbWhite = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    viewBox='0 0 450 450'
    style={{ enableBackground: 'new 0 0 450 450' }}
    xmlSpace='preserve'
    {...props}>
    <g>
      <g>
        <g>
          <path
            fill='#C78C2F'
            d='M216.5,99.9V90c0-1.4-1.2-2.6-2.6-2.6h-16v-5.1h16c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6h-18.6
            c-1.4,0-2.6,1.2-2.6,2.6V90c0,1.4,1.2,2.6,2.6,2.6h16v4.7h-16c-1.4,0-2.6,1.2-2.6,2.6v22c0,1.4,1.2,2.6,2.6,2.6
            c1.4,0,2.6-1.2,2.6-2.6v-19.4h16C215.3,102.5,216.5,101.3,216.5,99.9z'
          />
          <path
            fill='#C78C2F'
            d='M268.1,92.6c1.4,0,2.6-1.2,2.6-2.6V79.6c0-1.4-1.2-2.6-2.6-2.6h-18.6c-1.4,0-2.6,1.2-2.6,2.6
            s1.2,2.6,2.6,2.6h16v5.1h-16c-1.4,0-2.6,1.2-2.6,2.6v9.9c0,1.4,1.2,2.6,2.6,2.6h16v19.4c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6
            v-22c0-1.4-1.2-2.6-2.6-2.6h-16v-4.7H268.1z'
          />
        </g>
        <path
          fill='#C78C2F'
          d='M238.7,63v27c0,1.4,1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6V64.1c0-0.1,0-0.3,0-0.5c0-6.8-5.5-12.2-12.2-12.2
          s-12.2,5.5-12.2,12.1l0,26.5c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6l0-25.4l0-1c0-3.9,3.2-7,7-7c3.6,0,6.6,2.8,7,6.3
          C238.7,62.9,238.7,63,238.7,63z'
        />
        <path
          fill='#C78C2F'
          d='M234.3,151.1V79.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6v71.5H234.3z'
        />
        <g>
          <path
            fill='#C78C2F'
            d='M210.5,124.5c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3
            c4.9,0,8.9,4,8.9,9.5v28.9h5.2v-29.5c0-7.8-6.3-14.1-14.2-14.1c-4.7,0-8.5,3.8-8.5,8.5C202,120.7,205.8,124.5,210.5,124.5z'
          />
          <path
            fill='#C78C2F'
            d='M244,151.1v-29.5c0-4.9,4-8.9,9-8.9c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3c-1.4,0-2.6,1.2-2.6,2.6
            s1.2,2.6,2.6,2.6c4.7,0,8.5-3.8,8.5-8.5c0-4.7-3.8-8.5-8.5-8.5c-7.8,0-14.2,6.3-14.2,14.7v28.9H244z'
          />
        </g>
        <g>
          <path
            fill='#C78C2F'
            d='M231.7,387.8c6.1,0,11-4.9,11-11s-4.9-11-11-11c-6.1,0-11,4.9-11,11S225.7,387.8,231.7,387.8z M231.7,371
            c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.6,5.8-5.8,5.8c-3.2,0-5.8-2.6-5.8-5.8C225.9,373.6,228.5,371,231.7,371z'
          />
          <path
            fill='#C78C2F'
            d='M211.4,351.9c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6c4.5,0,8.2-3.7,8.2-8.2s-3.7-8.2-8.2-8.2
            c-7.5,0-13.5,6.1-13.5,13.5c0,7.5,6.1,13.5,13.5,13.5c4.2,0,8.1-2,10.7-5.3c0.2-0.1,0.4-0.3,0.5-0.4l6.1-8.5
            c0.8-1.2,0.6-2.8-0.6-3.6c-1.2-0.8-2.8-0.6-3.6,0.6l-5.8,8.1c-0.1,0.1-0.3,0.2-0.3,0.3c-1.5,2.3-4.1,3.7-6.9,3.7
            c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c1.6,0,3,1.3,3,3C214.4,350.6,213,351.9,211.4,351.9z'
          />
          <path
            fill='#C78C2F'
            d='M275.8,354.6c0-13.5-11-24.4-24.4-24.4c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6
            c10.6,0,19.2,8.6,19.2,19.2c0,10.6-8.6,19.1-19.1,19.2c0,0-0.1,0-0.1,0c-1.4,0-2.6,1.2-2.6,2.6c0,9.4-7.6,17-17,17
            c-9.4,0-17-7.6-17-17c0-1.4-1.2-2.6-2.6-2.6c0,0-0.1,0-0.1,0c-10.5-0.1-19.1-8.6-19.1-19.2c0-10.6,8.6-19.2,19.2-19.2
            c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-13.5,0-24.4,11-24.4,24.4c0,12.7,9.7,23,22.1,24.2c1.2,11.1,10.6,19.8,22,19.8
            c11.4,0,20.8-8.7,22-19.8C266.1,377.6,275.8,367.3,275.8,354.6z'
          />
          <path
            fill='#C78C2F'
            d='M252.1,340.7c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6
            c-1.6,0-3-1.3-3-3c0-1.6,1.3-3,3-3c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3c-2.8,0-5.4-1.4-6.9-3.7c-0.1-0.1-0.2-0.2-0.3-0.3
            l-30.8-43c3.8-3.7,8.3-4.3,8.4-4.3c1.3-0.2,2.3-1.3,2.3-2.6v-12h-5.2v10c-2.7,0.8-7.2,2.7-10.8,7.1c-0.7,0.9-0.8,2.2-0.1,3.2
            l32.3,45.2c0.1,0.2,0.4,0.3,0.5,0.5c2.6,3.3,6.4,5.3,10.7,5.3c7.5,0,13.5-6.1,13.5-13.5C265.6,346.8,259.5,340.7,252.1,340.7z'
          />
          <path
            fill='#C78C2F'
            d='M234.3,314.5v-18h-5.2v17.9c-2.2,0.4-4.3,1.2-6.1,2.6c-1.2,0.8-1.4,2.5-0.6,3.6c0.8,1.2,2.5,1.4,3.6,0.6
            c3.3-2.4,8-2.4,11.3,0c0.5,0.3,1,0.5,1.5,0.5c0.8,0,1.6-0.4,2.1-1.1c0.8-1.2,0.6-2.8-0.6-3.6
            C238.6,315.7,236.5,314.9,234.3,314.5z'
          />
          <path
            fill='#C78C2F'
            d='M243.9,306.5v-10h-5.2v12c0,1.3,1,2.4,2.3,2.6c0.1,0,4.5,0.6,8.4,4.3l-14.2,19.8c-0.8,1.2-0.6,2.8,0.6,3.6
            c0.5,0.3,1,0.5,1.5,0.5c0.8,0,1.6-0.4,2.1-1.1l15.4-21.5c0.7-0.9,0.6-2.2-0.1-3.2C251.2,309.2,246.6,307.3,243.9,306.5z'
          />
        </g>
      </g>
      <g>
        <path
          fill='#FFFFFF'
          d='M268.7,167.7h-25.9c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.5,0.4,1,0.9,1.1c6.5,1.6,7.7,2.6,7.7,4.4
          c0,1.1-0.4,2.3-0.8,3.4l-14.6,41.8l-14.6-45.4l-0.2-0.8c-0.1-0.4-0.3-0.8-0.1-1.1l8.1-2.4c0.5-0.1,0.8-0.6,0.8-1.1v-6.2
          c0-0.6-0.5-1.2-1.2-1.2h-30.2c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.5,0.4,1,0.9,1.1c5.6,1.5,5.6,1.5,6.7,5l22.5,63.4
          c0.2,0.5,0.6,0.8,1.1,0.8h9.2c0.5,0,0.9-0.3,1.1-0.8l25.4-66.6c0.3-0.3,2.9-1,5.8-1.8c0.5-0.1,0.9-0.6,0.9-1.1v-6.2
          C269.9,168.2,269.4,167.7,268.7,167.7z'
        />
        <path
          fill='#FFFFFF'
          d='M354.5,185.8c6.2-3.1,14.1-11.7,14.1-25.7c0-17.4-12.1-27.4-33.2-27.4H294c-0.6,0-1.2,0.5-1.2,1.2v6.2
          c0,0.6,0.4,1,0.9,1.1c9.9,1.9,9.9,3,9.9,8.7v78.2c0,5.8,0,6.8-9.9,8.7c-0.5,0.1-0.9,0.6-0.9,1.1v6.2c0,0.6,0.5,1.2,1.2,1.2h45.5
          c24.6,0,35.6-16,35.6-31.9C375,200.7,366.3,189.2,354.5,185.8z M319.7,192.8h15.7c5,0,21.5,1.6,21.5,22.1
          c0,12.8-9.8,19.9-27.5,19.9c-5.8,0-8-1.3-8.2-1.5c-1.2-0.6-1.5-2.1-1.5-4.5V192.8z M319.7,182v-38.6h8.4
          c10.5,0,22.9,3.2,22.9,18.6c0,12.2-9.6,20-24.5,20H319.7z'
        />
        <path
          fill='#FFFFFF'
          d='M143,228.1l0,0.9c0,5.1,0,6-9,7.8c-0.5,0.1-0.9,0.6-0.9,1.1v6.2c0,0.6,0.5,1.2,1.2,1.2h34.9
          c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8l0-6.2c0-0.5-0.4-1-0.9-1.1l-8.2-1.9c-1.8-0.4-2-1.1-2-3v-85.8c0-1.9,0.2-2.6,2-3
          l8.3-1.9c0.5-0.1,0.9-0.6,0.9-1.1v-6.2c0-0.6-0.5-1.2-1.1-1.2h-34.9c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.6,0.4,1,0.9,1.1
          c9.1,1.8,9.1,2.7,9,7.8l0,33h-41.9l0-35.9c0-1.9,0.2-2.6,1.9-3l8.3-1.9c0.5-0.1,0.8-0.6,0.8-1.1v-6.2c0-0.6-0.5-1.2-1.1-1.2H76.2
          c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.6,0.4,1,0.9,1.1c9.1,1.8,9.1,2.7,9,7.8l0,79.1l0,0.9c0,5.1,0,6-9,7.8c-0.5,0.1-0.9,0.6-0.9,1.1
          v6.2c0,0.6,0.5,1.2,1.2,1.2H111c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8l0-6.2c0-0.5-0.4-1-0.9-1.1l-8.2-1.9
          c-1.8-0.4-2-1.1-2-3l0-39.1H143L143,228.1z'
        />
      </g>
      <g>
        <path fill='#FFFFFF' d='M124.6,263.5h2.6V283h-2.6V263.5z' />
        <path
          fill='#FFFFFF'
          d='M134,262.7l14.4,14.9v-14.1h2.7v20.4l-14.4-14.8V283H134V262.7z'
        />
        <path
          fill='#FFFFFF'
          d='M273.5,262.7l14.4,14.9v-14.1h2.7v20.4l-14.4-14.8V283h-2.7V262.7z'
        />
        <path
          fill='#FFFFFF'
          d='M179,263.5h10.8v2.7h-8.2v4.9h8.2v2.6h-8.2v6.7h8.2v2.6H179V263.5z'
        />
        <path
          fill='#FFFFFF'
          d='M256,263.5h10.8v2.7h-8.2v4.9h8.2v2.6h-8.2v6.7h8.2v2.6H256V263.5z'
        />
        <path
          fill='#FFFFFF'
          d='M324.9,266.1l-2,1.6c-0.5-0.6-1-1-1.5-1.2c-0.4-0.3-1.1-0.4-1.9-0.4c-0.9,0-1.6,0.2-2.2,0.6
          c-0.6,0.4-0.8,0.9-0.8,1.6c0,0.6,0.2,1,0.7,1.5c0.5,0.4,1.3,0.9,2.5,1.4c1.2,0.5,2.1,1,2.7,1.4c0.7,0.4,1.2,0.9,1.6,1.4
          c0.4,0.5,0.7,1.1,0.9,1.7c0.2,0.6,0.3,1.2,0.3,1.9c0,1.5-0.6,2.8-1.7,3.9c-1.1,1.1-2.5,1.6-4,1.6c-1.5,0-2.9-0.4-4.1-1.3
          c-1.2-0.8-2.1-2.1-2.7-3.8l2.5-0.7c0.9,2.1,2.3,3.1,4.2,3.1c0.9,0,1.7-0.3,2.3-0.8c0.6-0.5,0.9-1.2,0.9-2.1c0-0.5-0.2-1-0.5-1.5
          c-0.3-0.5-0.7-0.9-1.2-1.2c-0.5-0.3-1.2-0.7-2.3-1.1c-1-0.4-1.8-0.8-2.4-1.2c-0.6-0.3-1-0.8-1.4-1.3c-0.4-0.5-0.7-1-0.9-1.4
          c-0.2-0.5-0.3-1-0.3-1.5c0-1.3,0.5-2.4,1.6-3.4c1.1-0.9,2.3-1.4,3.8-1.4c1,0,2,0.2,3,0.6C323.4,264.6,324.2,265.2,324.9,266.1z'
        />
        <path
          fill='#FFFFFF'
          d='M212.5,263.5h12v2.7h-4.7V283h-2.6v-16.9h-4.7V263.5z'
        />
        <path
          fill='#FFFFFF'
          d='M296.1,263.5h12v2.7h-4.7V283h-2.6v-16.9h-4.7V263.5z'
        />
        <polygon
          fill='#FFFFFF'
          points='165.1,277.6 158.7,263.5 155.8,263.5 165.1,283.9 174.3,263.5 171.5,263.5'
        />
        <polygon
          fill='#FFFFFF'
          points='245.1,262.7 239.1,277.3 232.9,262.7 227.6,283 230.2,283 233.5,270.5 238.7,283.2 239.1,283.9
          239.4,283.2 244.6,270.6 247.9,283 250.5,283'
        />
        <path
          fill='#FFFFFF'
          d='M207.2,266.1l-2,1.6c-0.5-0.6-1-1-1.5-1.2c-0.4-0.3-1.1-0.4-1.9-0.4c-0.9,0-1.6,0.2-2.2,0.6
          c-0.6,0.4-0.8,0.9-0.8,1.6c0,0.6,0.2,1,0.7,1.5c0.5,0.4,1.3,0.9,2.5,1.4c1.2,0.5,2.1,1,2.7,1.4c0.7,0.4,1.2,0.9,1.6,1.4
          s0.7,1.1,0.9,1.7c0.2,0.6,0.3,1.2,0.3,1.9c0,1.5-0.6,2.8-1.7,3.9c-1.1,1.1-2.5,1.6-4,1.6c-1.5,0-2.9-0.4-4.1-1.3s-2.1-2.1-2.7-3.8
          l2.5-0.7c0.9,2.1,2.3,3.1,4.2,3.1c0.9,0,1.7-0.3,2.3-0.8c0.6-0.5,0.9-1.2,0.9-2.1c0-0.5-0.2-1-0.5-1.5c-0.3-0.5-0.7-0.9-1.2-1.2
          c-0.5-0.3-1.2-0.7-2.3-1.1c-1-0.4-1.8-0.8-2.4-1.2c-0.6-0.3-1-0.8-1.4-1.3c-0.4-0.5-0.7-1-0.9-1.4c-0.2-0.5-0.3-1-0.3-1.5
          c0-1.3,0.5-2.4,1.6-3.4c1.1-0.9,2.3-1.4,3.8-1.4c1,0,2,0.2,3,0.6C205.6,264.6,206.5,265.2,207.2,266.1z'
        />
      </g>
    </g>
  </svg>
)

export default HvbWhite



// WEBPACK FOOTER //
// ./src/svg-icons/HvbWhite.js